import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import $ from 'jquery';

class Iframetemp extends Component {
  
 
  componentDidMount(){
  // console.log(2);    //
  }
  componentWillMount(){
    //console.log(1);
    // window.test();
  }

render() {
return (
    
      <div className="test-script h-100">This page is for import Iframe</div>
    );
  }
}
export default Iframetemp;